import React from "react";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";

const DistributorStockModal = ({ isOpen, toggle, product }) => {
    if (!product) return null;

    const distributorStock = product.distributor_stock || {};

    // Mapping of keys to display names
    const distributorNames = {
        dnh: "D&H",
        ingram: "Ingram",
        synnex: "Synnex",
        // Add more as needed
    };

    const stocks = Object.keys(distributorStock).map(key => ({
        name: distributorNames[key] || key.toUpperCase(),
        stock: distributorStock[key] || 0
    }));

    // If no stocks found, at least show D&H with 0 if it's the primary one, or show a message
    if (stocks.length === 0) {
        stocks.push({ name: "D&H", stock: 0 });
    }

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered size="md">
            <ModalHeader toggle={toggle} className="border-bottom-0">
                <h4 className="mb-0">Distributor Stock Details</h4>
                <small className="text-muted">{product.sku}</small>
            </ModalHeader>
            <ModalBody>
                <div className="mb-3">
                    <strong>Description:</strong>
                    <p className="text-muted small">{product.description}</p>
                </div>
                <Table hover bordered responsive className="text-center">
                    <thead>
                        <tr style={{ backgroundColor: "#00509d2E" }}>
                            <th>Distributor</th>
                            <th>Available Stock</th>
                        </tr>
                    </thead>
                    <tbody>
                        {stocks.map((s, index) => (
                            <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#3BE7FF12" : "#F7F7F780" }}>
                                <td className="font-weight-bold">{s.name}</td>
                                <td>
                                    <span className={`badge ${s.stock > 0 ? 'bg-success' : 'bg-danger'}`} style={{ fontSize: '14px' }}>
                                        {s.stock}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </ModalBody>
        </Modal>
    );
};

export default DistributorStockModal;
